const INTRO_KEYS = ["preguntas", "dato", "storytelling"];
const MENSAJE_KEYS = ["1", "2", "3"];
const CONCLUSION_KEYS = ["antesDespues", "recordatorio", "llamadaAccion"];

export function buildCrearMensajesState(t) {
  const introTextos = INTRO_KEYS.reduce((acc, key) => {
    acc[key] = t(`crearMensajes.intro.${key}.texto`);
    return acc;
  }, {});

  return {
    introTextos,
    collar: t("crearMensajes.collar.texto"),
    mensaje1Titulo: t("crearMensajes.mensajes.1.titulo"),
    mensaje1: t("crearMensajes.mensajes.1.cuerpo"),
    mensaje2Titulo: t("crearMensajes.mensajes.2.titulo"),
    mensaje2: t("crearMensajes.mensajes.2.cuerpo"),
    mensaje3Titulo: t("crearMensajes.mensajes.3.titulo"),
    mensaje3: t("crearMensajes.mensajes.3.cuerpo"),
    conclusionAntesDespues: t("crearMensajes.conclusion.antesDespues.texto"),
    conclusionRecordatorio: t("crearMensajes.conclusion.recordatorio.texto"),
    conclusionLlamadaAccion: t("crearMensajes.conclusion.llamadaAccion.texto"),
  };
}

export function getIntroOpciones(t) {
  return INTRO_KEYS.reduce((acc, key) => {
    acc[key] = {
      label: t(`crearMensajes.intro.${key}.label`),
    };
    return acc;
  }, {});
}

export function getConclusionBloques(t) {
  const meta = [
    { key: "antesDespues", color: "primary" },
    { key: "recordatorio", color: "secondary" },
    { key: "llamadaAccion", color: "success" },
  ];

  return meta.map(({ key, color }) => ({
    key,
    color,
    title: t(`crearMensajes.conclusion.${key}.title`),
    hint: t(`crearMensajes.conclusion.${key}.hint`),
  }));
}

export { INTRO_KEYS, MENSAJE_KEYS, CONCLUSION_KEYS };
